import { createFileRoute } from '@tanstack/react-router';

import { NotFound } from '@/components/not-found';

// Pre-rendered to `404.html`, which Static Web Apps rewrites to for an unmatched URL, keeping both
// that URL and the 404 status. React re-renders rather than hydrates as a result, since the route
// does not match the URL it is served at; a redirect to `/404` would trade that for a 302.
export const Route = createFileRoute('/404')({
  component: NotFound,
});
